export const STEPS_CONFIG = {
  STEP_CIRCLE_WIDTH: '0.75rem', // width of circle
  SM_STEP_CIRCLE_WIDTH: '0.5rem', // width of circle
  INIT_STEP: 0, // initialize current step
};

export const FREELY_WEBSITE_URL = 'https://www.freely.me';

export const FREELY_WEBSITE_ROUTES = {
  GET_HELP: 'get-help',
} as const;

export type FREELY_WEBSITE_ROUTES =
  (typeof FREELY_WEBSITE_ROUTES)[keyof typeof FREELY_WEBSITE_ROUTES];

export const EMAIL_QUOTE_FLOW_TYPE = {
  FOOTER: 'footer email a quote',
  ABANDON_CART: 'abandon cart popup',
} as const;

export type EMAIL_QUOTE_FLOW_TYPE =
  (typeof EMAIL_QUOTE_FLOW_TYPE)[keyof typeof EMAIL_QUOTE_FLOW_TYPE];
